import { ConfirmUI } from "./confirmUI";

export class Confirm {
  private ui: ConfirmUI = new ConfirmUI();
  private title: string = 'Are you sure?';

  public constructor(private text: string, private onConfirm: () => void, private onCancel: () => void) {
    this.ui.render(this.title, this.text,() => this.afterRender());
  }

  private afterRender() : void {
    this.ui.bind(this.handleConfirm.bind(this), this.handleCancel.bind(this));
  }

  private handleConfirm() : void {
    this.onConfirm();
    this.destroy();
  }

  private handleCancel() : void {
    this.onCancel();
    this.destroy();
  }


  private destroy() : void {
    this.ui.destroy();
  }
}
